import Layout from './layout'

export default [
  // 帮助中心
  {
    path: '/helpManage',
    component: Layout,
    meta: { groupTitle: '品库后台', roles: ['admin'] },
    hidden:false,
    children: [
      {
        path: '',
        name: 'helpManage',
        component: () => import(/* webpackChunkName: "helpManage" */ '@v/helpManage'),
        meta: { title: '帮助管理', icon: 'el_icon_question'},
      },
      {
        path: 'helpArticle/:id',
        name: 'helpArticle',
        hidden: true,
        component: () => import(/* webpackChunkName: "helpManage" */ '@v/helpManage/helpArticle'),
        meta: {
          title:'帮助文章',
          icon: 'main',
          showBreadcrumb: true,
        },
      },
    ],
  },
]